import { RefObject } from 'react'

export function lockBodyScroll(this: Element) {
  this.classList.add('transition-none')
  this.classList.add('mr-2')
  document.body.classList.add('hide-body-scroll')
  document.querySelector('#main-global-header')?.classList.add('main-global-header-hide-scroll')
}

export function unlockBodyScroll(this: Element) {
  this.classList.remove('mr-2')
  document.body.classList.remove('hide-body-scroll')
  document.querySelector('#main-global-header')?.classList.remove('main-global-header-hide-scroll')
}

const getElement = <R extends Element>(instance: string | RefObject<R[]>): Element[] | null =>
  typeof instance === 'string' ? Array.from(document.querySelectorAll(instance)) : instance.current

export const addLockListener = <R extends Element>(selector: string | RefObject<R[]>) => {
  const els = getElement<R>(selector)
  els?.forEach(el => {
    if (document.body.scrollHeight > document.body.clientHeight) {
      el.addEventListener('mouseover', lockBodyScroll, true)
      el.addEventListener('mouseleave', unlockBodyScroll, true)
      lockBodyScroll.call(el)
    }
  })
}

export const removeLockListener = <R extends Element>(selector: string | RefObject<R[]>) => {
  const els = getElement<R>(selector)
  els?.forEach(el => {
    if (document.body.scrollHeight > document.body.clientHeight) {
      el.removeEventListener('mouseover', lockBodyScroll)
      el.removeEventListener('mouseleave', unlockBodyScroll)
      el.classList.remove('transition-none')
      unlockBodyScroll.call(el)
    }
  })
}

export default { lockBodyScroll, unlockBodyScroll, addLockListener, removeLockListener }
